export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff', 'svg', 'heic'];
export const IMAGE_MIME_TYPE = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/tiff',
  'image/webp',
  'image/svg+xml',
  'image/heic',
];
export const VIDEO_EXTENSIONS = ['mp4', 'mov', 'mkv', 'wmv', 'flv', 'webm', 'quicktime'];
export const VIDEO_MIME_TYPE = [
  'audio/mpeg',
  'audio/wav',
  'video/mp4',
  'video/x-msvideo',
  'video/x-matroska',
  'video/webm',
  'video/quicktime',
];
export const SOUND_EXTENSIONS = ['mp3', 'wav', 'aac', 'flac', 'ogg', 'wma'];
export const SOUND_MIME_TYPE = ['audio/mpeg', 'audio/wav', 'audio/aac', 'audio/flac', 'audio/ogg', 'audio/wma'];
export const DOCS_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'odt'];
export const DOCS_MIME_TYPE = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/plain',
];

export const ALL_NEW_FILE_EXTENSIONS = [
  featArrayValues(IMAGE_EXTENSIONS),
  featArrayValues(VIDEO_EXTENSIONS),
  featArrayValues(SOUND_EXTENSIONS),
  featArrayValues(DOCS_EXTENSIONS),
].join(', ');

export const ALL_FILE_EXTENSIONS = '.' + IMAGE_EXTENSIONS.join(',.') + ',.' + VIDEO_EXTENSIONS.join(',.');
export const ALL_FILE_EXTENSIONS_VALIDATE = IMAGE_MIME_TYPE + VIDEO_MIME_TYPE + SOUND_MIME_TYPE + DOCS_MIME_TYPE;
export const ORGANIZATION_MODULE = 'organization';
export const ORGANIZATION_GROUP = 'organization';

function featArrayValues(arrs = []) {
  return arrs.map((ss) => '.' + ss).join(', ');
}
export const VIDEO_FILE_EXTENSIONS_VALIDATE = 'video/' + VIDEO_EXTENSIONS.join(',video/');
export const MAX_SIZE = 20; // MB
